import React from 'react'

function FooterTwo() {
    return (
        <div>
            <>
                {/* Start Footer Area  */}
                <footer style={{ marginTop: 0, paddingTop: 0 }} className="footer-area footer-style-one-wrapper bg-color-footer-2 bg_images tmp-section-gap">
                    <div className="container">
                        <div className="footer-main footer-style-one">
                            <div className="row g-5">
                                {/* Logo + About */}
                                <div className="col-lg-4 col-md-6">
                                    <div className="single-footer-wrapper border-right mr--20">
                                        <div className="logo">
                                            <a href="index.html">
                                                <img src="assets/images/logo/AQsv.svg" alt="logo" />
                                            </a>
                                        </div>
                                        <p className="description">
                                            AQ Audit Drives Growth Confidently, With Trusted Financial Insight & Strategic Compliance Support
                                        </p>
                                        <div className="day-time">
                                            <div className="icon">
                                                <i className="fa-solid fa-alarm-clock" />
                                            </div>
                                            <div className="content">
                                                <div className="day">Sunday - Friday:</div>
                                                <div className="time">9:00 AM – 8:00 PM</div>
                                            </div>
                                        </div>
                                        {/* <ul className="social-icons solid-social-icons rounded-social-icons">
                                            <li>
                                                <a href="#"><i className="fa-brands fa-facebook-f" /></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-linkedin-in" /></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-twitter" /></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-instagram" /></a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </div>

                                {/* Quick Links with bullet icons */}
                                <div className="col-lg-2 col-md-6">
                                    <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                                        <h5 className="ft-title">Quick Link</h5>
                                        <ul className="ft-link">
                                            <li><i className="fa-solid fa-angles-right me-2"></i><a href="/home-two">Home</a></li>
                                            <li><i className="fa-solid fa-angles-right me-2"></i><a href="/About">About Us</a></li>
                                            <li><i className="fa-solid fa-angles-right me-2"></i><a href="/ServiceDetails">Our Services</a></li>
                                            <li><i className="fa-solid fa-angles-right me-2"></i><a href="/Contact">Contact Us</a></li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Google Map */}
                                <div className="col-lg-3 col-md-6">
                                    <div className="single-footer-wrapper pr--15">
                                        <h5 className="ft-title">Find Us in Bahrain</h5>
                                        <div style={{ width: '100%', height: '200px', borderRadius: '10px', overflow: 'hidden' }}>
                                            <iframe
                                                title="Bahrain Location"
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7210.257460610342!2d50.5474413!3d26.2335844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49a7d432fa60f7%3A0xb31f3de4638d7298!2sSanabis%2C%20Bahrain!5e0!3m2!1sen!2sin!4v1659876543210!5m2!1sen!2sin"
                                                width="100%"
                                                height="200"
                                                style={{ border: 0 }}
                                                allowFullScreen=""
                                                loading="lazy"
                                                referrerPolicy="no-referrer-when-downgrade"
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>

                                {/* Corporate Address like Email & Phone */}
                                <div className="col-lg-3 col-md-6">
                                    <div className="single-footer-wrapper">
                                        <h5 className="ft-title">Corporate Address:</h5>
                                        <ul className="ft-link">
                                            <li>
                                                <div className="single-contact">
                                                    <div className="icon">
                                                        <i className="fa-solid fa-location-dot" />
                                                    </div>
                                                    <div className="content">
                                                        {/* <span>Address:</span> */}
                                                        <p className='description' style={{ margin: 0 }}>
                                                            Office 109, Building 628<br />
                                                            Road 1011, Block 410<br />
                                                            Sanabis, Manama<br />
                                                            P.O. Box 18569<br />
                                                            Kingdom of Bahrain
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="single-contact">
                                                    <div className="icon">
                                                        <i className="fa-solid fa-envelope-open-text" />
                                                    </div>
                                                    <div className="content">
                                                        <span>E-mail:</span>
                                                        <a href="mailto:info@aqauditing.com ">info@aqauditing.com</a>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="single-contact">
                                                    <div className="icon">
                                                        <i className="fa-light fa-phone" />
                                                    </div>
                                                    <div className="content">
                                                        <span>Phone:</span>
                                                        <a href="tel:+97317552383">+973 17552393</a>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </footer>

                {/* Copyright Area */}
                <div className="copyright-area-one two">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-md-6 text-start">
                                <div className="main-wrapper">
                                    <p>
                                        © Copyright 2025. All Rights Reserved by{" "}
                                        <a href="#">AQ Auditing</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6 text-end">
                                <a
                                    href="https://dhanamtechnologiesbh.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-flex align-items-center gap-2"
                                >
                                    <span style={{ marginTop: "20px", fontSize: "14px", color: "#777" }}>
                                        Powered by
                                    </span>
                                    <img
                                        src="assets/images/logo/d.webp"
                                        alt="Powered by Dhanam Technologies"
                                        style={{ height: '40px', marginTop: "20px" }}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Footer Area */}
            </>
        </div>
    )
}

export default FooterTwo
